import {useState/*, useEffect*/} from "react";
import {Nav} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'
import {Link} from "react-router-dom";


const NavbarMenu = ({mainUser, onUserLogged}) => {


    // const [loggedUser, setLoggedUser] = useState({token: "", message: "", state: "", userNameFamily: "", userMode: ""});

    /* useEffect(() => {
         const currentLoggedUser = JSON.parse(sessionStorage.getItem("user"));
         if (currentLoggedUser != null && currentLoggedUser.state === "success" && currentLoggedUser.token !== loggedUser.token) {
             setLoggedUser({
                 state: currentLoggedUser.state,
                 token: currentLoggedUser.token,
                 message: currentLoggedUser.message,
                 userMode: currentLoggedUser.user_mode,
                 userNameFamily: currentLoggedUser.user_name_family
             });
         }
     }, [mainUser, loggedUser.token]);*/

    /* useEffect(() => {
         onUserLogged(loggedUser);
     }, [loggedUser, onUserLogged]);*/

    const [navMenuButt, setNavMenuButt] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState(false);

    const logOut = () => {
        sessionStorage.clear();
        onUserLogged({token: "", message: "", state: "", userNameFamily: "", userMode: ""});
    }


    /*useEffect(() => {
        if (navMenuButt && !subMenuOpen)
            document.getElementById("navToggle").click();
    }, [subMenuOpen, navMenuButt,window.onclick])*/

    /*  const handleMouseAction = (e) => {
          const targetId = e.target.id;
          if ((targetId !== "dropdownUser1" && targetId !== "span-dropdown") && navMenuButt) {
              document.getElementById("navToggle").click();
              console.log(targetId)
          }
      }*/
    return (

        <nav
            className='font-link navbar navbar-expand-md fixed-top bg-dark navbar-light text-light text-center font-bold py-0'>

            <div className='container me-0 ms-0'>
                <Nav.Link href='/#' className='navbar-brand text-light font-bold fw-bolder'>
                    <img src='./imgs/logo.png' alt='' width='75' height='75'
                         className='d-inline-block align-text mx-2 px-1 fw-bolder'/>
                    فــراد</Nav.Link>
                <button className='navbar-toggler'
                    /* onBlur={() => {
                         console.log("on blur")
                         navMenuButt && document.getElementById("navToggle").click();
                     }}*/
                        onClick={() => {
                            setNavMenuButt(!navMenuButt)
                        }}
                        type='button'
                        id='navToggle'
                        data-bs-toggle='collapse'
                        data-bs-target='#nav-menu'>
                    <span><FontAwesomeIcon icon={faBars} color="white"/></span>

                </button>

                <div className='collapse navbar-collapse text-center' id='nav-menu'>
                    {mainUser.state === "success" &&
                    <ul className='navbar-nav text-light text-center bg-dark font-link fw-bolder'
                        onClick={() => {
                            setSubMenuOpen(true)
                            // console.log("onclick ul")
                        }}
                    >
                        <div className="dropdown text-light text-center">
                            <Nav.Link to="/"
                                      className="d-flex align-items-center justify-content-between text-light text-decoration-none dropdown-toggle"
                                      id="dropdownUser1" data-bs-toggle="dropdown" data-bs-target="#profile-drop"
                                      aria-expanded="false">
                                {/*<FontAwesomeIcon icon={["fas", "fa-user"]}/>*/}
                                {/*<i className="fa fa-user" width="40" height="40"></i>*/}
                                <span id="span-dropdown"
                                      onClick={() => {
                                          setSubMenuOpen(true)
                                          // console.log("onclick span")
                                      }}
                                      className="d-sm-inline mx-1 font-link fw-bolder">{mainUser.userNameFamily}</span>
                            </Nav.Link>
                            <ul id="profile-drop"
                                className="dropdown-menu dropdown-menu text-center justify-content-center text-small bg-dark">
                                <li><Link className="dropdown-item text-light font-link fw-bolder" to="/dashboard">
                                    پنل کاربری
                                </Link></li>
                                <li className="nav-item">
                                    <hr className="dropdown-divider"/>
                                </li>
                                <li className="nav-item dropdown-item">
                                    <Nav.Link className="nav-link text-light font-link fw-bolder"
                                              onClick={logOut}>
                                        خروج
                                    </Nav.Link>
                                </li>
                            </ul>
                        </div>
                    </ul>
                    }

                    <ul className='navbar-nav text-light fw-bolder'>

                        {
                            mainUser.state !== "success" &&
                            <>
                                {/*<li className='nav-item'>
                                    <Nav.Link href='/login' className='nav-link text-light'>ورود</Nav.Link>
                                </li>*/}
                                {/* <li className='nav-item'>
                                    <Nav.Link href='/sign_up' className='nav-link text-light'>ثبت نام</Nav.Link>
                                </li>*/}
                            </>
                        }

                        {/*<li className='nav-item'>
                            <Nav.Link href='/reserve_visit' className='nav-link text-light'>نوبت دهی پزشک</Nav.Link>
                        </li>*/}

                        <li className='nav-item'>
                            <Nav.Link href='/#about_us' className='nav-link text-light'>درباره فراد</Nav.Link>
                        </li>
                        <li className='nav-item'>
                            <Nav.Link href='/#contact_us' className='nav-link text-light'>راه های ارتباطی</Nav.Link>
                        </li>
                        <li className='nav-item'>
                            <Nav.Link href='/#question' className='nav-link text-light'>سوالات پر تکرار</Nav.Link>
                        </li>
                        <li className='nav-item'>
                            <Nav.Link href='/#jobs' className='nav-link text-light'>فرصت های شغلی</Nav.Link>
                        </li>

                        <li className='nav-item'>
                            <Nav.Link href='/download' className='nav-link text-light'>دانلود برنامه مِدمی</Nav.Link>
                        </li>
                     {/*   <li className='nav-item'>
                            <Nav.Link href='/agreements' className='nav-link text-light'>قراردادها و مجوز ها</Nav.Link>
                        </li>*/}
                        {/*<li className='nav-item'>
                            <Nav.Link href='/#licenses' className='nav-link text-light'>نماد ها</Nav.Link>
                        </li>*/}
                        {/*<li className='nav-item'>
                            <Nav.Link href='/blog' className='nav-link text-light'>بلاگ</Nav.Link>
                        </li>*/}
                    </ul>

                </div>
            </div>
        </nav>

    )
}

export default NavbarMenu